









































import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import { Getter, Mutation } from 'vuex-class';
import { mapGetters } from 'vuex';
import { ProposalMatch } from '../../../models/proposalmatch';

import { swiper, swiperSlide } from 'vue-awesome-swiper';

import { Photo } from '../../../models/photo';

@Component
export default class PhotoModal extends Vue {

    // Initialize to have values on render
    protected activePhoto: Photo = {
        id: 0,
        path: '',
        proposal_id: 0,
        type: 'Default',
    };

    // Data
    protected swiperOption = {
        slidesPerView: 1,
        spaceBetween: 10,
        loop: false,
        speed: 600,
        parallax: true,
        initialSlide: 0,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
            type: 'bullets',
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    };

     // Props
    @Prop() private isModalActive: boolean;
    @Prop() private initialPhoto: Photo;
    @Prop() private activeIndex: number;

    // Vuex
    @Getter('photo/photosOverview') private photos: Photo[];
    @Getter('configuration/photosLiked') private photosLiked: Photo[];
    @Getter('configuration/photosDisliked') private photosDisliked: Photo[];

    @Getter('configuration/isPhotoLiked') private isPhotoLiked;
    @Getter('configuration/isPhotoDisliked') private isPhotoDisliked;

    @Mutation('configuration/addLike') private addLike;
    @Mutation('configuration/addDislike') private addDislike;

    @Mutation('configuration/removeLike') private removeLike;
    @Mutation('configuration/removeDislike') private removeDislike;

    private mounted() {
        this.activePhoto = this.initialPhoto;

        // Slide to the clicked image
        this.swiper.slideTo(this.activeIndex, 0, false);

        // Add a event listener so we know when a slide has changed
        this.addSwiperChangeListener();
    }

    private addSwiperChangeListener() {
        // When there is a change set the current active photo
        this.swiper.on('slideChange', () => {
            this.activePhoto = this.photos[this.swiper.activeIndex];
        });
    }

    get swiper() {
        return (this.$refs.photoSwiper as swiper).swiper;
    }

    private like() {
        this.addLike(this.photos[this.swiper.activeIndex]);
        this.removeDislike(this.photos[this.swiper.activeIndex]);
    }

    private dislike() {
        this.addDislike(this.photos[this.swiper.activeIndex]);
        this.removeLike(this.photos[this.swiper.activeIndex]);
    }

    get isLiked() {
        return this.isPhotoLiked(this.activePhoto !== undefined ? this.activePhoto : this.initialPhoto);
    }

    get isDisliked() {
        return this.isPhotoDisliked(this.activePhoto !== undefined ? this.activePhoto : this.initialPhoto);
    }

    private toggleInfoModal() {
         this.$emit('toggleInfoModal');
    }

    private getImagePathByIndex(index) {
        return process.env.VUE_APP_BACKEND_URL + this.photos[index].path;
    }
}
